import { userService } from '../services/userService';
import { makeApiUrl } from '../helpers/makeApiUrl';
import {_url} from "../helpers/makeUrl";
import { userConstants } from '../constants/userConstants';
import { alertActions } from '../actions/alertActions';
import { langService } from '../services/langService';
import {projectPricesServices} from "../services/projectPricesServices";
import { hashLoginService } from '../services/hashLoginService'

export const userActions = {
    login,
    loginUsingHash,
    logout,
    getInfo,
    changeLangue,
    update,
}

function loginUsingHash(token) {
    return dispatch => {
        hashLoginService.login(token)
            .then(
                async user => {
                    dispatch(alertActions.clear());
                    dispatch(success(user));
                    const { privileges } = await projectPricesServices.userPrivileges(user)
                    if (privileges) {
                        user.user.privileges = privileges;
                        dispatch(success(user));
                        update(user)
                    }

                    window.location = _url('/')
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()));
                    window.location = 'https://abonline.pl'
                }
            );
    };

    function success(user) { return { type: userConstants.USER_INFO_SUCCESS, user } }
    function failure(error) { return { type: userConstants.USER_FAILURE, error } }
}


function login(username, password) {
    return dispatch => {
        dispatch(request({ username }));

        userService.login(username, password)
            .then(
                async user => {
                    dispatch(alertActions.clear());
                    dispatch(success(user));
                    const { privileges } = await projectPricesServices.userPrivileges(user)

                    if (privileges) {
                        user.user.privileges = privileges;
                        dispatch(success(user));
                        update(user)
                    }
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()));
                    window.location = 'https://abonline.pl'
                }
            );
    };

    function request(user) { return { type: userConstants.USER_REQUEST, user } }
    function success(user) { return { type: userConstants.USER_INFO_SUCCESS, user } }
    function failure(error) { return { type: userConstants.USER_FAILURE, error } }
}

function logout() {
    userService.logout();
    return { type: userConstants.LOGOUT };
}

function getInfo() {
    return dispatch => {
        dispatch(request());
        userService.getInfoFromUrl()
            .then(
                user => dispatch(success(user)),
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };

    function request() { return { type: userConstants.USER_REQUEST } }
    function success(user) { return { type: userConstants.USER_INFO_SUCCESS, user } }
    function failure(error) { return { type: userConstants.USER_FAILURE, error } }
}

function changeLangue(lang)
{
    langService.set(lang)
    return { type: userConstants.USER_CHANGE_LANGUE, lang };
}

function update(user)
{
    userService.update(user)
    return { type: userConstants.USER_INFO_SUCCESS, user }
}
